<!-- <head>
  <style>
    ::ng-deep .ngx-pagination {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      padding-left: 0;
      width: 100%;
      margin: 2.5rem auto;
    }

    ::ng-deep .ngx-pagination li.current {
      background-color: #39b54a;
      border-radius: 5px;
    }
  </style>
</head> -->
<div class="search-box">
  <ng-container *ngIf="channel; else logo">
    <div class="bg-channel">
      <img [src]="channel?.cover" />
    </div>
    <h1>{{ channel?.name }}</h1>
  </ng-container>
  <ng-template #logo>
    <div class="logo">
      <img src="/assets/images/logo-green.png" />
    </div>
  </ng-template>
  <section class="social-icons" *ngIf="channel || !channel">
    <a
      href="https://www.facebook.com/El-Green-Post-100503435935365"
      target="_blank"
    >
      <figure>
        <i class="fab fa-facebook-f"></i>
      </figure>
    </a>
    <a href="https://www.instagram.com/elgreenpost/" target="_blank">
      <figure>
        <i class="fab fa-instagram"></i>
      </figure>
    </a>
  </section>
  <app-search [params]="queryParams" (sendQuery)="onQuery($event)">
  </app-search>
</div>

<div class="container" id="container" #container>
  <ng-container *ngIf="bannerImg">
    <a
      href="https://tienda.elgreenpost.com/"
      target="_blank"
      class="ads"
      [innerHTML]="bannerImg"
    ></a>
  </ng-container>

  <div class="loader" *ngIf="showLoader">
    <img src="assets/images/loader.gif" />
  </div>

  <!-- <section *ngIf="!showLoader && blogPosts && blogPosts.length" class="desk">
    <section class="blog-slider">
      <swiper
        [config]="config"
        (swiper)="onSwiper($event)"
        (slideChange)="onSlideChange()"
      >
        <ng-template swiperSlide *ngFor="let post of blogPosts">
          <a class="post" [href]="post.link">
            <figure class="post_image">
              <img [src]="post.jetpack_featured_media_url" alt="post image" />
            </figure>
            <div class="post_info">
              <span class="post_info-date">{{
                post.date | date: "yyyy-MM-dd"
              }}</span>
              <h2 class="post_info-title">{{ post.title.rendered }}</h2>
              <p
                class="post_info-text"
                [innerHTML]="
                  post.excerpt.rendered.length > 150
                    ? (post.excerpt.rendered | slice: 0:150) + '...'
                    : post.excerpt.rendered
                "
              ></p>
              <div class="post_info-boton">Opinión</div>
            </div>
          </a>
        </ng-template>
      </swiper>
    </section>
  </section> -->

  <div
    infiniteScroll
    [infiniteScrollDistance]="2"
    [infiniteScrollThrottle]="50"
    (scrolled)="onScroll()"
    class="noticias_all"
  >
    <!-- <section
      *ngIf="!showLoader && blogPosts && blogPosts.length"
      class="mobile"
    >
      <section class="blog-slider">
        <swiper
          [config]="config"
          (swiper)="onSwiper($event)"
          (slideChange)="onSlideChange()"
        >
          <ng-template swiperSlide *ngFor="let post of blogPosts">
            <a class="post" [href]="post.link">
              <figure class="post_image">
                <img [src]="post.jetpack_featured_media_url" alt="post image" />
              </figure>
              <div class="post_info">
                <span class="post_info-date">{{
                  post.date | date: "yyyy-MM-dd"
                }}</span>
                <h2 class="post_info-title">{{ post.title.rendered }}</h2>
                <div class="post_info-boton">Blog</div>
              </div>
            </a>
          </ng-template>
        </swiper>
      </section>
    </section> -->
    <p *ngIf="articles.length === 0 && !showLoader" class="not-found">
      No se encontrarón resultados
    </p>
    <div *ngFor="let item of articles" class="noticia">
      <a (click)="goArticle(item._id)">
        <div class="noticia__logo">
          <img [src]="getSrc(item.page_id)" />
        </div>
        <div class="imagen">
          <img
            [src]="item.image"
            onerror="this.src='/assets/images/image-not-found.jpg'"
          />
        </div>

        <div class="info">
          <div class="fecha">{{ item.date }}</div>

          <div
            class="title"
            [innerHTML]="
              item.title
                | highlightKeywords : keywords
                | highlightSearch : search
            "
          ></div>

          <div class="boton">{{ item.channels }}</div>
        </div>
      </a>
    </div>
  </div>
  <div class="clr" #clr></div>
</div>

<button class="gotopbtn" (click)="goToTop()">
  <i class="fas fa-angle-double-up"></i>
</button>
<button class="gobottombtn" (click)="goToBottom()">
  <i class="fas fa-angle-double-down"></i>
</button>

<div
  class="start-modal"
  *ngIf="startSplashOpen"
  (click)="closeStartSplash($event)"
>
  <div class="start-modal_content">
    <figure class="start-modal_content_brand">
      <img
        src="./../../../../../assets/images/logo-splash.png"
        alt="TheGreenPost Brand Logo"
      />
    </figure>
    <div class="start-modal_content_grid">
      <div class="start-modal_content_grid_store">
        <figure class="start-modal_content_grid_store_image">
          <img
            src="./../../../../../assets/images/splash_store_img.png"
            alt="Go to store banner"
          />
        </figure>
        <p>
          Ve a una tienda de <strong>productos exclusivos con cannabis.</strong>
        </p>
        <button type="button" (click)="goNews()">Ir a la tienda</button>
      </div>
      <div class="start-modal_content_grid_news">
        <figure class="start-start-modal_content_grid_news-image">
          <img
            src="./../../../../../assets/images/splash_news_img.png"
            alt="Go to store banner"
          />
        </figure>
        <p>
          Mantente al dia con artículos y
          <strong>noticias sobre el cannabis.</strong>
        </p>
        <button
          class="start-modal_content_grid_news_button"
          type="button"
          (click)="closeStartSplash($event)"
        >
          Quiero actualizarme
        </button>
      </div>
    </div>
    <!-- <div class="close" (click)="closeStartSplash($event)">
      <i class="fas fa-times"></i>
    </div>
    <img
      src="assets/images/start-splash.jpg"
      alt="The green post descriptive splash"
    /> -->
  </div>
</div>
